import script from "./SearchByPhysicalData.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchByPhysicalData.vue?vue&type=script&setup=true&lang=ts"

import "./SearchByPhysicalData.vue?vue&type=style&index=0&id=33a80760&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33a80760"]])

export default __exports__